import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { translationHookOptions } from "../../../app/localization/localization";
import { RootStoreContext } from "../../../app/stores/rootStore";

const LaserButton: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { isLaserEnabled, isZoomed , ZwibblerUseLaserTool, ZwibblerEnableReadOnlyMode } =
    rootStore.zwibblerStore;
  const { theme } = rootStore.commonStore;
  const [t] = useTranslation(["browse_page"], translationHookOptions);

  const handleClick = () => {
    if(isLaserEnabled)ZwibblerEnableReadOnlyMode();
    else ZwibblerUseLaserTool();
  };

  return (
    <>
      <Button
        id="Laser"
        className={classNames(
          "w-100 px-1 pt-1 pb-1 transparentButton toolbarButton",
          isLaserEnabled
            ? `${theme!.toolbarActiveIconColor}`
            : `${theme!.toolbarIconColor}`
        )}
        disabled={isZoomed}
        color=""
        onClick={() => handleClick()}
        style={{ position: "relative" }}
      >
        <i
          className={classNames(
            "fas fa-marker iconToolbarButton",
            isLaserEnabled ? "" : ""
          )}
        ></i>
        <h6 className="textToolbarButton mb-0">{t("toolbar_laser_button")}</h6>
      </Button>
    </>
  );
};

export default observer(LaserButton);
